module.exports = __webpack_public_path__ + "static/media/channels-funnel.aa724327.png";